import { Tabs } from '@ygtechnologies/rubus-ui';
import React from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { ProfileInvitationsTable } from './ProfileInvitationsTable';
import { BuyerInvitationsTable } from './BuyerInvitationsTable';

export type InvitationsTab = 'profile' | 'buyers';

interface InvitationsPageProps {
    tab?: InvitationsTab;
}

interface TabSettings {
    id: InvitationsTab;
    name: string;
    component: React.ComponentType;
}

const tabs: TabSettings[] = [
    {
        id: 'profile',
        name: 'Profile Invitations',
        component: ProfileInvitationsTable,
    },
    {
        id: 'buyers',
        name: 'Buyer Invitations',
        component: BuyerInvitationsTable,
    },
];

const InvitationsPage: React.FC<InvitationsPageProps> = () => {
    const { tab } = useParams<{ tab?: InvitationsTab }>();
    const activeTab = tab || 'profile';
    const activeTabConfig = tabs.find((x) => x.id === activeTab);
    const ActiveComponent = activeTabConfig?.component;

    return (
        <div>
            <h2>Invitations</h2>
            <Tabs.Container activeId={activeTab} variant="underline">
                {tabs.map((tabConfig) => (
                    <Tabs.Tab
                        key={tabConfig.id}
                        id={tabConfig.id}
                        as={Link}
                        to={`/invitations/${tabConfig.id}`}
                        label={tabConfig.name}
                    />
                ))}
                <Tabs.Content>
                    <div className="tab-panel">{ActiveComponent && <ActiveComponent />}</div>
                </Tabs.Content>
            </Tabs.Container>
        </div>
    );
};

export default InvitationsPage;
